import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0b97342e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "ticket_wrapper" }
const _hoisted_2 = { class: "ticket_title" }
const _hoisted_3 = { id: "ticket" }
const _hoisted_4 = { id: "ticket_id" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_6 = { class: "row mainDivText" }
const _hoisted_7 = { class: "col leftCol" }
const _hoisted_8 = { class: "col middleCol" }
const _hoisted_9 = { class: "col rightCol" }
const _hoisted_10 = { class: "row mainDivText" }
const _hoisted_11 = { class: "col leftCol" }
const _hoisted_12 = { class: "col rightCol" }
const _hoisted_13 = {
  key: 0,
  class: "row mainDivText"
}
const _hoisted_14 = { class: "col leftCol" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col middleCol" }, null, -1))
const _hoisted_16 = { class: "col rightCol credit" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_18 = { class: "row mainDivText" }
const _hoisted_19 = { class: "col leftCol" }
const _hoisted_20 = { class: "col rightCol totalPayment" }

import useScan2payStore from '../../store/scan2pay';
    import useQrStore from '../../store/qr';
    import { onMounted, computed, inject } from 'vue';
    import { useRouter } from 'vue-router';
    import { formatDate, formatTime, formatHours, formatCurrency } from '../../utils/formatters';
    
export default /*#__PURE__*/_defineComponent({
  __name: 'Ticket',
  setup(__props) {

    const qrStore = useQrStore();
    const scan2payStore = useScan2payStore();
    const router = useRouter();
    const $t = inject('$t', (value: string) => value);

    function formatToDate(date) {
        if (date === undefined) return null;
        let documentDirection = document.dir;
        return formatDate(new Date(date), documentDirection);
    }

    function formatToTime(date) {
        if (date) return formatTime(new Date(date));
    }

    function formatToHours(minutes) {
        if (minutes) return formatHours(minutes, $t);
    }

    function formatToCurrency(number) {
        if (number !== undefined && number !== null) {
            const currencyCode = qrStore.currencyCode;
            return formatCurrency(number, currencyCode);
        }
    }

    function goBackToSearchPage() {
        var staticQr = window.sessionStorage.getItem('staticQr');

        router.push({
            name: 'Search',
            params: { staticQr: staticQr },
        });
    }

    const ticketDetails = computed(() => scan2payStore.paymentDetails);

  onMounted(async () => {
    if (!scan2payStore.paymentDetails) goBackToSearchPage();
  });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("span", _hoisted_3, _toDisplayString(_unref($t)('Ticket #')) + " ", 1),
        _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(ticketDetails)?.ticketNumber), 1)
      ]),
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, _toDisplayString(_unref($t)('Entry')) + ":", 1),
        _createElementVNode("div", _hoisted_8, _toDisplayString(formatToDate(_unref(ticketDetails)?.entryDateTime)), 1),
        _createElementVNode("div", _hoisted_9, _toDisplayString(formatToTime(_unref(ticketDetails)?.entryDateTime)), 1)
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, _toDisplayString(_unref($t)('Duration(hours)')) + ":", 1),
        _createElementVNode("div", _hoisted_12, _toDisplayString(formatToHours(_unref(ticketDetails)?.duration)), 1)
      ]),
      (_unref(ticketDetails)?.validationsSum > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, _toDisplayString(_unref($t)('Discount')) + ":", 1),
            _hoisted_15,
            _createElementVNode("div", _hoisted_16, " -" + _toDisplayString(formatToCurrency(_unref(ticketDetails)?.validationsSum)), 1)
          ]))
        : _createCommentVNode("", true),
      _hoisted_17,
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("div", _hoisted_19, _toDisplayString(_unref($t)('Total Payment')) + ":", 1),
        _createElementVNode("div", _hoisted_20, _toDisplayString(formatToCurrency(_unref(ticketDetails)?.totalPayment)), 1)
      ])
    ])
  ]))
}
}

})